import { BRAND } from "../../data/brand";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="px-5 sm:px-8 py-16 border-t border-white/10"
    >
      <div className="max-w-[1400px] mx-auto">
        {/* Partnership lockup */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-10 pb-12 border-b border-white/10">
          <div className="flex items-center gap-3">
            <img
              src={BRAND.logo}
              alt="Train With Tristian"
              className="h-12 w-12 object-contain"
            />
            <span className="font-display font-bold text-sm tracking-tight leading-tight">
              TRAIN WITH <span className="gold-text">TRISTIAN</span>
            </span>
          </div>

          <span className="text-neutral-600 text-xs tracking-[0.3em] uppercase">
            In Partnership With
          </span>

          <div className="bg-white rounded-md px-4 py-2.5 flex items-center">
            <img
              src={BRAND.anytimeLogo}
              alt="Anytime Fitness"
              data-testid="anytime-logo"
              className="h-7 sm:h-8 w-auto object-contain"
            />
          </div>
        </div>

        <div className="pt-12 flex flex-col sm:flex-row items-center justify-between gap-6 text-center sm:text-left">
          <div>
            <p className="text-neutral-400 font-light">{BRAND.location}</p>
            <a
              href={`mailto:${BRAND.email}`}
              data-testid="footer-email"
              className="text-[#d4af37] hover:text-[#f3e5ab] transition-colors"
            >
              {BRAND.email}
            </a>
          </div>

          <a
            href="#apply"
            data-testid="footer-cta"
            className="text-xs tracking-[0.15em] uppercase font-bold border-b border-[#d4af37] pb-1 hover:text-[#d4af37] transition-colors"
          >
            Apply Now →
          </a>
        </div>

        <p className="mt-12 text-neutral-600 text-xs">
          © {new Date().getFullYear()} {BRAND.name}. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
